import React, { useContext } from 'react';

const PricingReactContext = React.createContext(undefined);
function usePricingContext() {
    const context = useContext(PricingReactContext);
    if (!context) {
        throw new Error("usePricingContext must be used with PricingContextProvider");
    }
    return context.context;
}

export { PricingReactContext, usePricingContext };
//# sourceMappingURL=context.mjs.map
